<template lang="pug">
  v-dialog(v-model='dialog', max-width='1000')
    roulete(
      v-if='dialog'
      @close='close'
    )

</template>
<script> 
import Roulete from '../Roulete.vue'
import { ROUTE_SETTING } from '../../const/route'
export default {
  components:{
    Roulete
  },
  data: () => ({
    dialog: false,    
  }) ,
  computed: {
    wallet () {
      return this.$store.getters['userProfile/GETTERS_WALLET']
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
  },
  methods: {
    close () {
      this.dialog = false
    },
    open () {

      if (this.userProfile.bank_type === null) {
        this.$alert('กรุณาตั้งค่าบัญชีธนาคารของท่าน','', 'warning').then(() => {
          this.$router.push({ name: ROUTE_SETTING, query: { tab: 'bank' } }).catch(() => {}); 
        });

        return
      }

      this.dialog = true
    }
  }
} 
</script>